import { useContext, createContext } from "react";
import { useLoaderData, type LoaderFunction } from "react-router";

import { Api, Types } from "@/services";
import { JobsContainer, SearchContainer } from "@/components";

interface AllJobsContextType {
  data: Types.Response.JobsList;
  searchValues: Record<string, string>;
}

const AllJobsContext = createContext<AllJobsContextType>({
  data: { total: 0, pages: 0, currentPage: 0, jobs: [] },
  searchValues: {},
});

export const allJobsLoader: LoaderFunction = async ({ request: { url } }) => {
  const params = Object.fromEntries([...new URL(url).searchParams.entries()]) as unknown as Types.Request.JobsList;

  const { data } = await Api.JobsList(params);
  return { data, searchValues: params ?? {} };
};

const AllJobs = () => {
  const { data, searchValues } = useLoaderData<AllJobsContextType>();

  return (
    <AllJobsContext.Provider value={{ data, searchValues }}>
      <SearchContainer />
      <JobsContainer />
    </AllJobsContext.Provider>
  );
};

export const useAllJobsContext = () => useContext(AllJobsContext);

export default AllJobs;
